import { ADD_TEAM, ADD_TEAM_FAIL, ADD_TEAM_SUCCESS } from './actionTypes';

const initialState = {
    userToAdd: {},
    addedUser: {},
    error: null,
    loading: false,
    loaded: false
};

export function addTeamReducer(state = initialState, action) {
    switch (action.type) {
        case ADD_TEAM:
            return {
                ...initialState,
                userToAdd: action.payload,
                loading: true
            };
        case ADD_TEAM_SUCCESS:
            return {
                ...state,
                addedUser: action.payload,
                loaded: true,
                loading: false
            };
        case ADD_TEAM_FAIL: {
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        }
        default:
            return state;
    }
}
